<div class="flex align-items-center justify-content-center mt-5 w-full">
	<div *ngFor="let p of display">
		<input
			 class="custom-otp-input p-2" 
			 [class]="pin.length === pinLength ? 'border-bottom-2 border-primary' : ''"
			 [value]="p"
			 disabled="true"
			 />
	</div>
	<p-button id="buttonQuickEasyAccessViewPin" pTooltip="{{ 'SEE_PIN' | translate }}"
		tooltipPosition="bottom" [icon]="!visibleMode ? 'pi cm-eye' : 'pi cm-eye-not'" size="large"
		(click)="toggleVisibility()" [rounded]="false" [text]="true" severity="secondary">
	</p-button>
</div>

<div class="flex align-items-center justify-content-center mt-5 w-full">
	<div class="card px-6 pb-7 flex flex-column border-1 border-gray-600" style="background-color: #54575C; border-radius: 35px;">
		<div class="flex flex-row align-items-center justify-content-center">
			<img src="./assets/images/logos/CAME-A_alpha_white_blue.png" alt="CAME Logo" class="w-7rem pb-3 pt-2">
		</div>
		<div class="card py-1 px-4 bg-blue-500 border-2 border-gray-600" style="border-radius: 10px;">
			<div class="grid mt-0 max-w-16rem">
				<div class="col-4 flex justify-content-center px-0 py-1" *ngFor="let btn of pinpadBtns">
					<button pButton pRipple
						label="{{btn}}" (click)="onKeyPressed(btn)" [class]="pin.length === pinLength ? 'bg-blue-900 text-0' : 'bg-bluegray-600 text-blue-200'"
						class="font-medium border-round-md text-5xl w-5rem h-3_5rem"
						[disabled]="pin.length === pinLength">
					</button>
				</div>
				<div class="col-4 flex justify-content-center px-0 py-1">
					<button pButton pRipple label="*" style="font-family: Roboto;"
						(click)="onClearPressed()" [class]="pin.length === 0 ? 'bg-blue-800' : 'bg-red-700'"
						class="font-semibold border-round-md text-900 text-5xl w-5rem h-3_5rem"
						[disabled]="pin.length === 0"
						>
					</button>
				</div>
				<div class="col-4 flex justify-content-center px-0 py-1">
					<button pButton pRipple
						label="0" (click)="onKeyPressed(0)" [class]="pin.length === pinLength ? 'bg-blue-900 text-0' : 'bg-bluegray-600 text-blue-200'"
						class="font-medium border-round-md text-5xl w-5rem h-3_5rem"
						[disabled]="pin.length === pinLength"
						>
					</button>
				</div>
				<div class="col-4 flex justify-content-center px-0 py-1">
					<button pButton pRipple label="#" style="font-family: Roboto;"
						(click)="onOkPressed()" [class]="pin.length !== pinLength ? 'bg-blue-800' : 'bg-green-700'"
						class="font-semibold border-round-md text-900 text-5xl w-5rem h-3_5rem"
						[disabled]="pin.length !== pinLength"
						>
					</button>
				</div>
			</div>
		</div>
	</div>
 </div>

<!-- <div class="grid p-fluid">
  <div class="col-12 p-0 md:p-1 lg:px-8">
    <div class="card">
		<div class="grid" style="padding-top: 100px;">
			<span *ngFor="let p of display">{{ p }}</span>
			<p-button label="visible"
				tooltipPosition="bottom" size="large" [disabled]="pin.length === pinLength"
				(click)="toggleVisibility()" [rounded]="false" [text]="true" severity="danger">
			</p-button>
		</div>
		<div class="grid">
			<p-button label="{{btn}}" *ngFor="let btn of pinpadBtns" 
				tooltipPosition="bottom" size="large" [disabled]="pin.length === pinLength"
				(click)="onKeyPressed(btn)" [rounded]="false" [text]="true" severity="danger">
			</p-button>

			<p-button label="clear"
				tooltipPosition="bottom" size="large" [disabled]="pin.length === pinLength"
				(click)="onClearPressed()" [rounded]="false" [text]="true" severity="danger">
			</p-button>
			<p-button label="0"
				tooltipPosition="bottom" size="large" [disabled]="pin.length === pinLength"
				(click)="onKeyPressed(0)" [rounded]="false" [text]="true" severity="danger">
			</p-button>
			<p-button label="check"
				tooltipPosition="bottom" size="large" [disabled]="pin.length !== pinLength"
				(click)="onOkPressed()" [rounded]="false" [text]="true" severity="danger">
			</p-button>
    	</div>
    </div>
  </div>
</div> -->
